//@ts-check
import React, { useRef, useState, useEffect } from 'react';
import { FolderWorkflowConfigRow } from './FolderWorkflowConfigRow';
import { Pagination } from '../../_shared/Grid/Pagination';

const FolderWorkflowConfigList = ({
    configs,
    workflows,
    onUpdate,
    onDelete,
    editingConfigId,
    onEditStart,
    onEditCancel,
    pageIndex,
    pageSize,
    totalPages,
    totalCount,
    handlePageIndexChange
}) => {
    const bodyRef = useRef(null);
    const [scrollbarWidth, setScrollbarWidth] = useState(0);


    useEffect(() => {
        let timerId;

        const handleResize = () => {
            clearTimeout(timerId);
            timerId = setTimeout(calculateHeaderWidth, 150);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            clearTimeout(timerId);
            window.removeEventListener('resize', handleResize);
        };
    }, [configs]);

    const calculateHeaderWidth = () => {
        const body = bodyRef.current;
        if (!body) return;

        const rectWidth = body.getBoundingClientRect().width;

        const width = rectWidth - body.clientWidth;

        console.log('rect rectWidth: ' + rectWidth);
        console.log('rect width: ' + width);

        if (scrollbarWidth === width) {
            return;
        }
        setScrollbarWidth(width);
    };

    const onPageChanged = (data) => {
        handlePageIndexChange(data.selected);
    };

    return (
        <div className="folder-workflow-list-wrapper">
            <div className="folder-workflow-table">
                <div
                    className="folder-workflow-table__header-host"
                    style={{ paddingRight: scrollbarWidth + 'px' }}>
                    <div className="folder-workflow-table__header">
                        <div className="folder-workflow-table__cell folder-workflow-table__cell--icon"></div>
                        <div className="folder-workflow-table__cell">Folder</div>
                        <div className="folder-workflow-table__cell">Default Workflow</div>
                        <div className="folder-workflow-table__cell">Default Status</div>
                    </div>
                </div>

                <div className="folder-workflow-table__body" ref={bodyRef}>
                    {configs.map((config) => (
                        <FolderWorkflowConfigRow
                            key={config.id || config.directoryId}
                            config={config}
                            workflows={workflows}
                            onUpdate={onUpdate}
                            onDelete={onDelete}
                            isEditing={editingConfigId === (config.id || config.directoryId)}
                            onEditStart={onEditStart}
                            onEditCancel={onEditCancel}
                            hasEditingConfig={editingConfigId !== null}
                        />
                    ))}
                </div>
            </div>

            {totalCount > 0 && (
                <div className="folder-workflow-pager">
                    <Pagination
                        totalPages={totalPages}
                        pageSize={pageSize}
                        totalCount={totalCount}
                        selectedPage={pageIndex}
                        pageChanged={onPageChanged}
                        showCountText={true}
                        showPageSizeChanger={false}
                    />
                </div>
            )}
        </div>
    );
};

export { FolderWorkflowConfigList };
